import { ProductType } from '@app-types/product';

export const TAG_CATEGORIES: { [key in ProductType]?: string } = {
    phone: 'Telephone',
    phone_simple: 'Telephone',
    accessory: 'Accessoire',
    accessory_configurable: 'Accessoire',
    box: 'Hotspot_tablette',
};
